/** API route map: URLS.Controller.PayrollCostCenter */
export const PayrollCostCenter = {
      Name: 'PayrollCostCenter/',
      GetAll: 'getall',
      Add: 'add',
      Delete: 'delete',
      Update: 'update',
      GetCostCenter: 'get-costCenterName',
      GetAllCostCenters: 'get-all-cost-centers',
};
